export default class RGBA
{

  constructor(r,g,b,a) {
    this.r = r;

    if (typeof g === 'undefined') {
      g = r;
      b = r;
    }

    this.g = Math.floor(g);
    this.b = Math.floor(b);
    this.a = a;
  }

  random() {
    this.r = Math.round(Math.random() * 255);
    this.g = Math.round(Math.random() * 255);
    this.b = Math.round(Math.random() * 255);
    return this;
  }

  red(r) {
    this.r = r;
    return this;
  }

  green(g) {
    this.g = g;
    return this;
  }

  blue(b) {
    this.b = b;
    return this;
  }

  alpha(a) {
    this.a = a;
    return this;
  }

  toString() {
    if (this.a) {
      return 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + this.getA() + ')';
    }
    return 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')';

  }

  getA() {
    if (this.a < 1) {
      return this.a;
    }
    return '1.0';
  }

}
